import {
  TTranslationEvent,
} from '@/components/item-notification/item-notification.ts';

const event: TTranslationEvent = {
  job_finished: {
    label: '{assetDisplayName}',
    description: 'Zákazka {displayName} z receptúry: {recipeDisplayName} bola dokončená o {finishedAtUtc} na {assetDisplayName} v {locationDisplayName}.\nPopis zákazky: {description}',
  },
  job_started: {
    label: '{assetDisplayName}',
    description: 'Zákazka {displayName} bola spustená o {startedAtUtc} a dokončená o {finishedAtUtc} na {assetDisplayName} v {locationDisplayName}.\nPopis zákazky: {description}',
  },
  timeseries_lag_detected: {
    label: '{assetDisplayName}',
    description: 'Bolo zistené oneskorenie časového radu zariadenia {assetDisplayName} v lokalite {locationDisplayName}',
  },
  alarm_occurred: {
    label: '{assetDisplayName}',
    description: '{severityTranslation} \'{alarmDisplayName}\' zistený na {assetDisplayName} v {locationDisplayName}',
  },
  new_qmulus_release: {
    label: 'Nová verzia Qmulus',
    description: 'Qmulus v{version} práve vydaný. Pozrite si poznámky k vydaniu pre viac informácií',
  },
  control_level_exceeded: {
    label: 'Prekročená úroveň kontroly',
    description: 'Bola prekročená kontrolná úroveň odčítaní snímača',
  },
  drift_detected: {
    label: 'Zistený drift',
    description: 'Odčítania snímača sa odchyľujú od referenčnej hodnoty',
  },
  trend_detected: {
    label: 'Zistený trend',
    description: 'Qmulus zistil nový trend v odčítaniach snímača',
  },
  maintenance_occurrence_state_changed: {
    label: 'Stav údržby bol zmenený',
    description: 'Stav údržby {seriesDisplayName} na {assetDisplayName} bol zmenený na {maintenanceStateTranslation}',
  },
};

export default {
  markAsRead: 'Označiť ako prečítané',
  goToEvent: 'Prejsť na udalosť',
  event,
  timeseriesLagStopped: {
    label: '{assetDisplayName}: Oneskorenie časového radu skončilo',
    description: 'Oneskorenie časového radu zariadenia {assetDisplayName} v lokalite {locationDisplayName} skončilo',
  },
};
